import {DragDropModule} from '@angular/cdk/drag-drop';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {NbCheckboxModule, NbIconModule, NbInputModule, NbToggleModule} from '@nebular/theme';
import {SortPipe} from 'compob2b-libs';

import {BaseComponent} from 'compob2b-table';

import {NgxPaginationModule} from 'ngx-pagination';

import {GlobalSearchPipe} from '../../pipes/global-search-pipe';
import {RenderPipe} from '../../pipes/render-pipe';
import {SearchPipe} from '../../pipes/search-pipe';

import {HeaderComponent} from '../header/header.component';
import {PaginationComponent} from '../pagination/pagination.component';
import {TableTHeadComponent} from '../thead/thead.component';

@NgModule({
  declarations: [
    BaseComponent,
    HeaderComponent,
    PaginationComponent,
    TableTHeadComponent,

    // Pipes
    SearchPipe,
    RenderPipe,
    GlobalSearchPipe,
  ],
  imports: [CommonModule, NgxPaginationModule, DragDropModule, ScrollingModule, NbIconModule, NbCheckboxModule, NbToggleModule, NbInputModule, SortPipe],
  exports: [BaseComponent, PaginationComponent],
})
export class BaseModule {
}
